import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { Reminder } from '@classes/reminder';

@Injectable({
  providedIn: 'root'
})
export class RemindersService {
  private baseUrl: string = environment.apiUrl + 'reminders';
  private reminder: Reminder;

  constructor(
    private http: HttpClient
  ) { }

  getByOrderId(orderId: string): Observable<Reminder[]> {
    return this.http.get<Reminder[]>(`${this.baseUrl}?orderId=${orderId}`);
  }

  post(orderId: string, dateTime: string): Observable<Reminder> {
    let recallTimer =
    {
      orderId: orderId,
      dateTime: dateTime
    }
    return this.http.post<Reminder>(`${this.baseUrl}`, recallTimer);
  }

  sendReminder(orderId: string): Observable<any> {
    let body =
    {
      orderId: orderId
    }
    return this.http.post<Reminder>(`${this.baseUrl}/send-reminder`, body);
  }

  put(reminder: Reminder): Observable<Reminder> {
    return this.http.put<Reminder>(`${this.baseUrl}`, reminder);
  }

  delete(reminder: Reminder): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}`, { body: reminder });
  }
}
